export default {
  HEADER_SET_STATE: '@header/HEADER_SET_STATE',
  HEADER_NOTIFICATIONS_REQUEST: '@header/HEADER_NOTIFICATIONS_REQUEST',
};
